import React from "react";
import SearchField from "../SearchField";

export default function GuestListControls({ search, onSearchChange, sort, onSortChange }) {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_9.5rem] gap-2"
      data-testid="dash-guest-list-controls"
    >
      <SearchField
        value={search}
        onChange={onSearchChange}
        label="Search guests by name"
        placeholder="Search by name"
        testId="dash-guest-search"
        clearTestId="clear-guest-search"
      />
      <label className="block">
        <span className="sr-only">Sort guests</span>
        <select
          className="field w-full"
          value={sort}
          onChange={(e) => onSortChange(e.target.value)}
          data-testid="dash-guest-sort"
        >
          <option value="name">Name A–Z</option>
          <option value="role">Role</option>
        </select>
      </label>
    </div>
  );
}
